import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function ArrowWithLineLargeIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path d="M3.977 13h12.205l-5.606 5.59L12 20l8.023-8L12 4l-1.414 1.41L16.182 11H3.977Z" />
    </IconWrapper>
  );
}
